import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { StoreStockMessageQueue } from 'types/storeStockMessageQueue'

const addStoreStockMessageQueue = (params: {
  breadRef: FirebaseDocRefType
  storeRef: FirebaseDocRefType
}): Promise<void> => {
  const { breadRef, storeRef } = params
  const now = FirebaseTimestamp.now()
  const storeStockMessageQueue: StoreStockMessageQueue = {
    created_at: now,
    bread_ref: breadRef,
    store_ref: storeRef,
    updated_at: now,
  }
  return storeRef.collection('store_stock_message_queues').doc().set(storeStockMessageQueue)
}

export default addStoreStockMessageQueue
